// import request from '@/utils/request'
import axios from '@/http/api'


//3.2.15 获取组织流媒体状态
export const selectMediaOrg = data => {
  return axios({
    url: '/consoleGateway/organizationController/selectMediaState',
    method: 'post',
    data
  })
}

//getPublicCloud //3.1.12 获取工程私有云设置
export const getPublicCloud = data => {
  return axios({
    url: '/manageGateway/userInfoController/getPublicCloud',
    method: 'post',
    data
  })
}



// WEBPACK FOOTER //
// ./src/api/common.js